import swipe from 'mint-ui/lib/swipe';
import 'mint-ui/lib/swipe/style.css';
import swipeItem from 'mint-ui/lib/swipe-item';
import 'mint-ui/lib/swipe-item/style.css';

export { swipe, swipeItem };
